import React, { ReactNode } from 'react';
import {
  BulkAddDialog,
  BulkAddDialogProps,
  DialogComponentProps,
  InviteUserDialog,
  InviteUserDialogProps,
  ManageCompanyUsersDialog,
  ManageCompanyUsersDialogProps,
} from '.';

const renderBulkAddDialog = (props: BulkAddDialogProps) => <BulkAddDialog {...props} />;

const renderInviteUserDialog = (props: InviteUserDialogProps) => <InviteUserDialog {...props} />;

const renderManageCompanyUsersDialog = (props: ManageCompanyUsersDialogProps) => (
  <ManageCompanyUsersDialog {...props} />
);

const getDialogComponent = ({ type, props }: DialogComponentProps): ReactNode | null => {
  const { bulkAddProps, inviteUserProps, manageCompanyUsersProps } = props;
  const dialogMap: Record<string, () => ReactNode> = {
    bulkAdd: () => renderBulkAddDialog(bulkAddProps),
    inviteUser: () => renderInviteUserDialog(inviteUserProps),
    manageCompanyUsers: () => renderManageCompanyUsersDialog(manageCompanyUsersProps),
  };

  return dialogMap[type]?.() ?? null;
};

export default getDialogComponent;
